module.exports = __webpack_public_path__ + "img/no-image.1101a879.svg";